export const SG_APP_STORE_APP_URL =
  'https://apps.apple.com/us/app/sweetgreen/id594329490';
export const SG_PLAY_MARKET_APP_URL =
  'https://play.google.com/store/apps/details?id=com.sweetgreen.android.app&gl=US';
